export const items = [
  {
    label: 'HappyPressed',
    value: 'happy'
  },
  {
    label: 'OkPressed',
    value: 'ok'
  },
  {
    label: 'AngryPressed',
    value: 'angry'
  }
];

// eslint-disable-next-line
export const optionsFirstChart: any = {
  responsive: true,
  plugins: {
    legend: {
      display: false
    },
    title: {
      display: true,
      text: 'Customers Satisfaction',
      align: 'start',
      color: '#1B242D',
      padding: {
        bottom: 50
      },
      font: { family: 'Ubuntu-Regular', size: 16, weight: '600' }
    },
    datalabels: {
      display: false
    }
  },
  scales: {
    x: {
      grid: { display: false }
    },
    y: {
      grid: { tickColor: '#fff' },
      type: 'linear',
      min: 0
    }
  }
};
